import { Skeleton } from "@mui/material";
import React from "react";

import "./table.css";

const Table = ({
  headData,
  renderHead,
  bodyData,
  renderBody,
  pages,
  currPage,
  changePage,
  loading,
}) => {
  // const initDataShow = props.limit && props.bodyData ? props.bodyData.slice(0, Number(props.limit)) : props.bodyData

  // const [dataShow, setDataShow] = useState(initDataShow)

  // let pages = 1

  // let range = []

  // if (props.limit !== undefined) {
  //     let page = Math.floor(props.bodyData.length / Number(props.limit))
  //     pages = props.bodyData.length % Number(props.limit) === 0 ? page : page + 1
  //     range = [...Array(pages).keys()]
  // }

  // const [currPage, setCurrPage] = useState(0)

  // const selectPage = page => {
  //     const start = Number(props.limit) * page
  //     const end = start + Number(props.limit)

  //     setDataShow(props.bodyData.slice(start, end))

  //     setCurrPage(page)
  // }

  return (
    <div>
      <div className="table-wrapper">
        <table>
          {headData && renderHead ? (
            <thead>
              <tr className="desc">
                {headData.map((item, index) => renderHead(item, index))}
              </tr>
            </thead>
          ) : null}

          {loading ? (
            <>
              <tbody>
                <tr>
                  {headData.map((v, i) => (
                    <td key={i}>
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={"100%"}
                        height={100}
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </>
          ) : bodyData && renderBody ? (
            <tbody>
              {bodyData.map((item, index) => renderBody(item, index))}
            </tbody>
          ) : null}
        </table>
      </div>
      {pages > 1 ? (
        <div className="table__pagination">
          {Array.from(Array(pages).keys()).map((item, index) => (
            <div
              key={index}
              className={`table__pagination-item ${
                currPage === index ? "active" : ""
              }`}
              onClick={() => changePage(item)}
            >
              {item + 1}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default Table;
